
export class BaseRequest {

}



// WEBPACK FOOTER //
// ./src/vas/services/share/base-request.ts